<form nz-form [formGroup]="timesheetSearchForm">
  <div nz-row gutter="16" style="display: flex; flex-wrap: wrap; align-items: flex-end; width: 100%">

    <!-- Filter Items -->

    <div nz-col *ngIf="timesheetSearchForm.controls['Timeframe']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a Timeframe'">
          <nz-select formControlName="Timeframe" class="filters" id="Timeframe" nzPlaceHolder="Timeframe" nzShowSearch
            style="width: 100%;">
            @for(opt of loopback; track $index) {
            <nz-option [nzLabel]="'Last ' + opt.val" [nzValue]="opt.val"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['status']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3"
      [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a status'">
          <nz-select formControlName="status" class="filters" id="status" nzPlaceHolder="Status" nzShowSearch
            nzAllowClear style="width: 100%;">
            @for(opt of statusList; track $index){
            <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueCode"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['processStatusLkp']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a Process Status'">
          <nz-select formControlName="processStatusLkp" class="filters" id="ProcessStatus"
            nzPlaceHolder="Process Status" nzShowSearch nzAllowClear style="width: 100%;">
            @for(opt of processStatusList; track $index){
            <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueCode"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['processStatusLkup']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a Process Status'">
          <nz-select formControlName="processStatusLkup" class="filters" id="ProcessStatus"
            nzPlaceHolder="Process Status" nzShowSearch nzAllowClear style="width: 100%;">
            @for(opt of filteredProcessStatusList; track $index){
            <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueCode"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['serviceDate']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a service date'">
          <nz-date-picker formControlName="serviceDate" id="serviceDate" nzPlaceHolder="Service Date"
            [nzFormat]="'MM/dd/yyyy'" nzShowSearch nzAllowClear style="width: 100%; height: 32px"></nz-date-picker>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['payPeriod']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a service period'">
          <nz-select formControlName="payPeriod" class="filters" id="payPeriod" nzPlaceHolder="Service Period"
            nzShowSearch nzAllowClear style="width: 100%;">
            @for(opt of payPeriod; track $index){
            <nz-option [nzLabel]="opt.payPeriod" [nzValue]="opt.payrollId"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['consumer']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please enter consumer name'">
          <input placeholder="Consumer Name" nz-input (input)="onInput($event, 'consumer')" formControlName="consumer"
            id="consumer" />

        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['consumerPplId']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please enter Consumer PPL ID'">
          <input placeholder="Consumer PPL ID" nz-input (input)="onInput($event, 'consumerPplId')"
            formControlName="consumerPplId" id="consumerPplId" />
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['provider']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please enter provider name'">
          <input placeholder="Provider Name" nz-input (input)="onInput($event, 'provider')" formControlName="provider"
            id="provider" />
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['providerPplId']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please enter Provider PPL ID'">
          <input placeholder="Provider PPL ID" nz-input (input)="onInput($event, 'providerPplId')"
            formControlName="providerPplId" id="providerPplId" />
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['paymentDate']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a payment date'">
          <nz-select formControlName="paymentDate" id="paymentDate" nzPlaceHolder="Pay Period" nzShowSearch nzAllowClear
            style="width: 100%;">
            @for(opt of payPeriod; track $index){
            <nz-option [nzLabel]="opt.payPeriod" [nzValue]="opt.payrollId"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['chequeNumber']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please enter cheque number'">
          <input nz-input formControlName="chequeNumber" id="chequeNumber" placeholder="Check Number" />
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['serviceCode']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a Service Code'">
          <nz-select formControlName="serviceCode" class="filters" id="payPeriod" nzPlaceHolder="Service Code"
            nzShowSearch nzAllowClear style="width: 100%;">
            @for(opt of timesheetServiceCodes; track $index){
            <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueCode"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['processCode'] && processCodes" [nzXs]="24" [nzSm]="12" [nzMd]="8"
      [nzLg]="4" [nzXl]="7" [nzXXl]="7" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a Process Code'">
          <nz-select formControlName="processCode" class="filters" id="processCode" nzPlaceHolder="Process Code"
            nzShowSearch nzAllowClear style="width: 100%;">
            @for(opt of processCodes; track $index){
            <nz-option [nzLabel]="opt.displayName" [nzValue]="opt.processCodeDetailId"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <!-- Search Button (Always aligned right) -->
    <div nz-col [nzSpan]="24" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3"
      style="text-align: right; margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <ppl-button label="Search" icon="fa fa-filter" style="margin-top: -2px;" [customClass]="'ghost-button'"
          [iconPosition]="'left'" (click)="search()"
          *authorize="[pageId, tabId, 'AddTimeenties', 'section', 'edit']"></ppl-button>
      </nz-form-item>
    </div>

  </div>
</form>